module.exports = __webpack_public_path__ + "img/Kiyotaka.f2ea85d1.jpeg";